export default __webpack_public_path__ + "static/media/shoes1-afterA-1920w.4c129f06.png";